import { useRouter } from 'next/router';
import { OriginalFooter } from 'src/components/shared/templates/footer/OriginalFooter';
import { Footer as WAfooter } from 'wamazing-UI-components-react/src/components/footer';
import { type LanguagesType } from 'wamazing-UI-components-react/src/models/languagesType';

export const Footer: React.FC = () => {
  const { locale } = useRouter();

  return (
    <>
      <OriginalFooter />
      <WAfooter lang={locale as LanguagesType} productName="kaimono" />
    </>
  );
};
